export enum LeadAutomationTerminalStatuses {
All,
Won,
Lost,
Pending,
}
